import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminShell({ title, subtitle, tabs, active, onTab, children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex">
      <aside className="w-60 shrink-0 bg-[#2C3531] text-white flex-col hidden md:flex">
        <div className="flex items-center gap-2 px-6 py-6 border-b border-white/10">
          <Sparkles className="w-5 h-5" style={{ color: "#C9BCA0" }} />
          <span className="font-serif text-xl font-bold">Grow Your Bookings</span>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {tabs.map((t) => (
            <button key={t.key} data-testid={`nav-${t.key}`} onClick={() => onTab(t.key)}
              className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${active === t.key ? "bg-white/15 text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`}>
              <t.icon className="w-4 h-4" /> {t.label}
            </button>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 text-xs text-white/50 truncate">{user?.email}</div>
          <button data-testid="logout-btn" onClick={() => { logout(); nav("/admin/login"); }}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium text-white/60 hover:text-white hover:bg-white/5 transition-colors">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 flex flex-col">
        <header className="sticky top-0 z-20 bg-white/70 backdrop-blur-xl backdrop-saturate-150 border-b border-[#E8E6E1] px-6 md:px-10 py-5">
          <h1 className="font-serif text-2xl md:text-3xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="text-sm text-[#787672] mt-0.5">{subtitle}</p>}
          <div className="flex gap-2 mt-4 md:hidden overflow-x-auto">
            {tabs.map((t) => (
              <button key={t.key} onClick={() => onTab(t.key)}
                className={`px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${active === t.key ? "bg-[#2C3531] text-white" : "bg-[#F0EFEB] text-[#787672]"}`}>
                {t.label}
              </button>
            ))}
          </div>
        </header>
        <div className="flex-1 p-6 md:p-10 overflow-auto">{children}</div>
      </main>
    </div>
  );
}
